import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import WarehouseService from '../services/WarehouseService';

const initialState = {
  data: [],
  datas: [],
  formError: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 10,
    totalPages: 10,
  },
  error: null,
  status: '',
  loading: false,
  submitLoading: false,
};

export const warehouseList = createAsyncThunk(
  'warehouse/list',
  async ({ perPage, page, keyword }) => {
    try {
      const resp = await WarehouseService.List({ perPage, page, keyword });
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const warehouseAdd = createAsyncThunk('warehouse/add', async (data) => {
  try {
    const resp = await WarehouseService.Create(data);
    return resp;
  } catch (e) {
    return e.response;
  }
});

export const warehouseEdit = createAsyncThunk('warehouse/edit', async ({ id, data }) => {
  try {
    const resp = await WarehouseService.Put(id, data);
    return resp;
  } catch (e) {
    return e.response;
  }
});

export const warehouseDelt = createAsyncThunk('warehouse/delt', async (id) => {
  try {
    const resp = await WarehouseService.Delt(id);
    return resp;
  } catch (e) {
    return e.response;
  }
});

export const getAllWarehouses = createAsyncThunk(
  'warehouse/all',
  async () => {
    try {
      const resp = await WarehouseService.All();
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

const warehouseAction = createSlice({
  name: 'warehouse',
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(warehouseList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(warehouseList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data?.data?.warehouses];
          state.pagination = action.payload?.data?.data?.pagination;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(warehouseList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(warehouseAdd.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(warehouseAdd.fulfilled, (state, action) => {
        state.status = '';
        if (action.payload?.status === 200) {
          state.datas.unshift(action.payload?.data?.data?.warehouse);
          state.info = action.payload?.data.message;
          state.status = 'achieve';
          toast.success(action.payload?.data.message);
        } else {
          toast.error(action.payload?.data.message);
        }
        state.formError = action.payload?.data.errors;
        state.submitLoading = false;
      })
      .addCase(warehouseAdd.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(warehouseEdit.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
      })
      .addCase(warehouseEdit.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.info = action.payload?.data.message;
          const index = state.datas.findIndex(
            (client) => client.id === action.payload.data?.data?.warehouse?.id,
          );
          state.datas[index] = {
            ...state[index],
            ...action.payload.data?.data?.warehouse,
          };
          toast.success(action.payload?.data.message);
        } else {
          toast.error(action.payload?.data.message);
        }
        state.formError = action.payload?.data.errors;
        state.submitLoading = false;
      })
      .addCase(warehouseEdit.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(warehouseDelt.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
      })
      .addCase(warehouseDelt.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          let index = state.datas.findIndex(({ id }) => id === action.payload.data?.data?.warehouse?.id);
          state.datas.splice(index, 1);
          state.info = action.payload?.data.message;
          toast.success(action.payload?.data.message);
        }
        state.submitLoading = false;
      })
      .addCase(warehouseDelt.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(getAllWarehouses.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllWarehouses.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data?.data];
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(getAllWarehouses.rejected, (state, action) => {
        state.error = action.payload?.data?.message;
        state.loading = false;
        toast.error(state.error);
      });
  },
});

const { reducer } = warehouseAction;

export const { openWarehouseDialog } = warehouseAction.actions;

export const warehouseSelector = (state) => state?.warehouse;

export default reducer;
